import Counterparty from "./Counterparty";
import RussianPassport from "./RussianPassport";
import Address from "./Address";
import CounterpartyVatHistory from "./CounterpartyVatHistory";

export default class CounterpartySoleProprietorship extends Counterparty {
  constructor(
    idInDB,
    externalId,
    itn,
    comment,
    counterpartyVatHistoryList,
    isIntragroupTurnover,
    firstName,
    lastName,
    patronymic,
    rrc,
    russianPassport,
    addresses
  ) {
    super(
      idInDB,
      externalId,
      "Sole proprietorship",
      itn,
      comment,
      counterpartyVatHistoryList,
      isIntragroupTurnover
    );

    this.firstName = firstName;
    this.lastName = lastName;
    this.patronymic = patronymic;

    this.rrc = rrc;
    this.russianPassport = russianPassport;
    this.addresses = addresses;
    this.displayName = this.getDisplayNameForList();
  }

  static createFromData(data) {
    const counterpartyVatHistoryList = data.counterpartyVatHistoryList
      ? data.counterpartyVatHistoryList.map(v =>
        CounterpartyVatHistory.createFromData(v)
      )
      : [];

    const russianPassport = data.russianPassport
      ? RussianPassport.createFromData(data.russianPassport)
      : RussianPassport.createNew();

    const addresses = data.addresses && data.addresses.length
      ? Address.createFromData(data.addresses)
      : [];

    return new CounterpartySoleProprietorship(
      data.counterparty.idInDB,
      data.counterparty.externalId,
      data.counterparty.itn,
      data.counterparty.comment,
      counterpartyVatHistoryList,
      data.counterparty.isIntragroupTurnover,
      data.counterparty.firstName,
      data.counterparty.lastName,
      data.counterparty.patronymic,
      data.counterparty.rrc,
      russianPassport,
      addresses
    );
  }

  static createNew() {
    const russianPassport = RussianPassport.createNew();

    return new CounterpartySoleProprietorship(
      null,
      null,
      null,
      null,
      [], // counterpartyVatHistoryList
      false, // isIntragroupTurnover
      null,
      null,
      null,
      null,
      russianPassport,
      []
    );
  }

  static convertToSendData(item) {
    return {
      counterparty: {
        externalId: item.externalId,
        counterpartyType: item.counterpartyType,
        firstName: item.firstName,
        lastName: item.lastName,
        patronymic: item.patronymic,
        itn: item.itn,
        comment: item.comment,
        isIntragroupTurnover: item.isIntragroupTurnover
      },
      counterpartyVatHistoryList: item.counterpartyVatHistoryList.map(v =>
        CounterpartyVatHistory.convertToSendData(v)
      ),
      russianPassport: { ...item.russianPassport },
      addresses: item.addresses.map(a =>
        new Address(a.addressType, a.address, a.idInDB)
      )
    };
  }


  getDisplayName() {
    return this.patronymic == null
      ? `ИП ${this.lastName} ${this.firstName}`
      : `ИП ${this.lastName} ${this.firstName} ${this.patronymic}`;
  }

  getDisplayNameForList() {
    return this.getDisplayName();
  }

  getRussianPassportDate() {
    if (
      this.russianPassport.dayDateDateOfIssue !== null &&
      this.russianPassport.monthDateDateOfIssue !== null
    ) {
      let day = this.russianPassport.dayDateDateOfIssue;
      let month = this.russianPassport.monthDateDateOfIssue;

      if (day.toString().length === 1) day = "0" + day;
      if (month.toString().length === 1) month = "0" + month;

      return `${day}.${month}.${this.russianPassport.yearDateDateOfIssue}`;
    }
  }
}
